import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useConfirmModal } from '@/contexts/ConfirmModalContext';
import Button from '@/components/common/Button';

interface ExpiredTicketModalContentProps {
  propsDetail?: string;
}

/**
 * チケット有効期限切れ時の購入導線モーダル（コンテンツ）
 * @param param0
 * @returns
 */
const ExpiredTicketModalContent: React.FC<ExpiredTicketModalContentProps> = ({ propsDetail }) => {
  const navigate = useNavigate();

  /**
   * React Context
   */
  const { closeConfirmModal } = useConfirmModal();
  // const { isOpen, closeDrawer } = useDrawer();

  // 利用チケット詳細へ遷移する
  const handleMoveToTickets = () => {
    navigate(`/me/tickets`);
    closeConfirmModal();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
      <div className="relative w-full max-w-md max-h-full p-4">
        <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div className="p-4 md:p-5 text-center">
            <svg
              className="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24">
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M10 11h2v5m-2 0h4m-2.592-8.5h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3 className="text-lg font-normal text-gray-500 dark:text-gray-400">
              チケットの有効期限が切れています。
              <br />
              すべての機能を利用するには、footballLOGチケットの購入が必要です。
            </h3>
            {propsDetail && <p className="mt-2 text-xs text-gray-500">{propsDetail}</p>}
            <div className="mt-8 flex justify-center items-center">
              <Button type="button" buttonType="outlinePrimary" className="me-4" onClick={handleMoveToTickets}>
                購入ページへ
              </Button>
              <Button type="button" buttonType="outlineSecondary" onClick={closeConfirmModal}>
                キャンセル
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpiredTicketModalContent;
